import { render, staticRenderFns } from "./myComment.vue?vue&type=template&id=49d8e5d2&functional=true&"
import script from "./myComment.vue?vue&type=script&lang=js&"
export * from "./myComment.vue?vue&type=script&lang=js&"
import style0 from "./myComment.vue?vue&type=style&index=0&id=49d8e5d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports